import type { LogoOverlay } from '@shared/types'
import { useEditorStore } from '../../../../store/editorStore'
import { SliderField } from '../../../common/Field'
import { InspectorFrame } from './InspectorFrame'
import { OVERLAY_KIND_LABEL } from '../overlayMeta'

/**
 * task spec §3-3: 「Logo は opacity のみ」。LogoOverlay
 * (shared/src/types.ts) は startSec/durationSec を持たない ── InspectorFrame に
 * それらを渡さないので開始秒/尺フッターは出ない(仕様通り)。position は
 * 'top-center' 固定でドラッグ不可(第2段 2a 側の仕様)なのでここにも編集 UI は置かない。
 */
export function LogoInspector({ overlay }: { overlay: LogoOverlay }) {
  const updateOverlay = useEditorStore((s) => s.updateOverlay)

  return (
    <InspectorFrame title={OVERLAY_KIND_LABEL.logo} overlayId={overlay.id} overlayKind="logo">
      <SliderField
        label="不透明度"
        value={overlay.opacity}
        min={0}
        max={1}
        step={0.01}
        onChange={(opacity) => updateOverlay(overlay.id, { opacity })}
      />
      <p className="text-[10px] text-text-faint leading-relaxed">
        ロゴは常時表示・位置は画面上部中央に固定です（ドラッグでは動かせません）。
      </p>
    </InspectorFrame>
  )
}
